import { render, staticRenderFns } from "./chartNormal.vue?vue&type=template&id=24b7aed5"
import script from "./chartNormal.vue?vue&type=script&lang=js"
export * from "./chartNormal.vue?vue&type=script&lang=js"
import style0 from "./chartNormal.vue?vue&type=style&index=0&id=24b7aed5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports